module.exports = __webpack_public_path__ + "static/media/035-serbia.4c9bd5d6.svg";